import React, { useState, useEffect, useRef } from 'react';
/* eslint-disable */
import * as Yup from 'yup';
// material
import { Container, Card, Grid } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment, Button, Box, FormControl, Checkbox, FormHelperText } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import { makeStyles } from '@material-ui/styles';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import services from '../Service';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import PropTypes from 'prop-types';
import SearchNotFound from '../../../SearchNotFound';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';

const useStyles = makeStyles({
  table: {
    minWidth: 750
  }
});

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "FCCACTIVITYSUMMARYREPORT"

export default function FCCActivitySummaryReport(props) {
  const classes = useStyles();
  const componentRef = useRef();
  const [date1, setDate1] = useState(new Date());
  const [date2, setDate2] = useState(new Date());
  const [groupFactory, setGroupFactory] = useState([]);
  const [operationEntityList, setOperationEntityList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const [fccSummaryDetails, setFCCSummaryDetails] = useState([]);
  const navigate = useNavigate();
  const [selectedOptionsFCC, setSelectedOptionsFCC] = useState([]);
  const [formData, setFormData] = useState({
    groupID: '0',
    operationEntityID: '0',
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "",
    factoryName: "",
    startDate: '',
    endDate: ''
  });
  const [totalValues, settotalValues] = useState({
    RequestedQtyTotal: 0,
    AcceptedQtyTotal: 0,
    SuppliedQtyTotal: 0
  });
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: selectedOptionsFCC,
      fromDate: date1.toISOString().split('T')[0],
      toDate: date2.toISOString().split('T')[0]
    },

    validationSchema: () => {
      return Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.array()
          .min(1, 'Please select at least one Fresh collection center')
          .required('Please select at least one Fresh collection center'),
        toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
      });
    },

    onSubmit: () => {
      trackPromise(SubmitForm());
    }
  }
  );

  async function SubmitForm() {
    let model = {
      GroupID: parseInt(formik.values.groupID),
      OperationEntityID: selectedOptionsFCC.map(x => x).join(',').toString(),
      FromDate: formik.values.fromDate,
      ToDate: formik.values.toDate
    }
    var res = await services.GetDetailsForFCCActivitySummaryReport(model);
    settotalValues({
      RequestedQtyTotal: 0,
      AcceptedQtyTotal: 0,
      SuppliedQtyTotal: 0
    })
    setPage(0);

    if (res.length > 0) {
      let totalRequestedQty = 0;
      let totalAcceptedQty = 0;
      let totalSuppliedQty = 0;

      res.forEach(x => {
        totalRequestedQty += x.quantity;
        totalAcceptedQty += x.acceptedQuantity;
        totalSuppliedQty += x.netAmount;
      });

      // res.sort((a, b) => a.orderDate > b.orderDate ? 1 : -1);
      res.sort((a, b) => new Date(b.orderDate) - new Date(a.orderDate));
      setFCCSummaryDetails(res)
      createDataForExcel(res);
      settotalValues({
        RequestedQtyTotal: totalRequestedQty,
        AcceptedQtyTotal: totalAcceptedQty,
        SuppliedQtyTotal: totalSuppliedQty

      });
      getSelectedDropdownValuesForReport(model);
    }
  }

  function getSelectedDropdownValuesForReport(data) {
    const facName = [];
    selectedOptionsFCC.forEach(x => {
      const fildered = operationEntityList.find(y => x === y.value).label
      facName.push(fildered)
    });
    let groups = groupList.find(x => x.groupID == formik.values.groupID)
    setSelectedSearchValues((prevState) => ({
      ...prevState,
      groupName: groups.groupName,
      factoryName: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(', '),
      startDate: data.FromDate,
      endDate: data.ToDate,
    }));
  }

  async function createFile() {
    var file = await createDataForExcel(fccSummaryDetails);
    var settings = {
      sheetName: 'FCC Activity Summary Report',
      fileName: 'FCC Activity Summary Report',
      writeOptions: {}
    }
    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })
    let dataA = [
      {
        sheet: 'FCC Activity Summary Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          'FCC': x.factoryName,
          'Date': moment(x.orderDate).format("YYYY-MM-DD"),
          'Product Code': x.productCode,
          'Product': x.productName,
          'Requested Qty': parseFloat(x.quantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'Accepted Qty': parseFloat(x.acceptedQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'Supplied Qty	': parseFloat(x.netAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
        res.push(vr);
      });
      var vrTotal = {
        'FCC': "Total",
        'Requested Qty': totalValues.RequestedQtyTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'Accepted Qty': totalValues.AcceptedQtyTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'Supplied Qty	': totalValues.SuppliedQtyTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
      res.push(vrTotal);
      res.push({});

      // var vr1 = {
      //   'FCC': "Group : " + selectedSearchValues.groupName,
      // }
      // res.push(vr1);

      // var vr2 = {
      //   'FCC': "Fresh Collection Center : " + selectedSearchValues.factoryName,
      // }
      // res.push(vr2);

      // var vr3 = {
      //   'FCC': "From : " + new Date(formik.values.fromDate).toLocaleDateString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 }),
      // }
      // res.push(vr3);

      // var vr4 = {
      //   'FCC': "To : " + new Date(formik.values.toDate).toLocaleDateString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })
      // }
      // res.push(vr4);
    }
    return res;
  }

  useEffect(() => {

    getPermissions();
  }, []);

  useEffect(() => {
    setPage(0);
    GetAllGroups();
  }, [])

  useEffect(() => {
    setPage(0);
    GetOperationEntityByGroupID();
  }, [formik.values.groupID]);

  useEffect(() => {
    setPage(0);
    clear();
    setValues({
      ...values,
      fromDate: date1.toISOString().split('T')[0],
      toDate: date2.toISOString().split('T')[0]
    })
  }, [formik.values.operationEntityID, selectedOptionsFCC]);

  useEffect(() => {
    setPage(0);
    setFCCSummaryDetails([]);
  }, [operationEntityList, formik.values.fromDate, formik.values.toDate]);

  useEffect(() => {
    setPage(0);
    setSelectedOptionsFCC(operationEntityList.map(option => option.value));
  }, [operationEntityList]);

  useEffect(() => {
    setPage(0);
    setValues({
      ...values,
      operationEntityID: selectedOptionsFCC

    })
  }, [selectedOptionsFCC]);

  useEffect(() => {
    setPage(0);
    const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
    const selectedOptions = [factoryValue];
    setSelectedOptionsFCC(selectedOptions)
  }, [operationEntityList]);

  const handleSelectChange = (event) => {
    const selectedValues = event.target.value;
    if (selectedValues.includes('')) {
      setSelectedOptionsFCC(
        selectedOptionsFCC.length === operationEntityList.length ? [] : operationEntityList.map((option) => option.value)
      );
    } else {
      setSelectedOptionsFCC(selectedValues);
    }
    setFCCSummaryDetails([]);
  };

  const handleClearSelection = () => {
    setSelectedOptionsFCC([]);
    setFCCSummaryDetails([]);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - fccSummaryDetails.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };



  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFCCACTIVITYSUMMARYREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })

    setGroupFactory({
      ...groupFactory,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
  }

  async function GetAllGroups() {
    var res = await services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      var newOptionArray = [];
      for (var i = 0; i < res.length; i++) {
        newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
      }
      setOperationEntityList(newOptionArray);
    }
  }

  async function clearAll() {
    if (!permissionList.isFactoryFilterEnabled) {
      setFCCSummaryDetails([]);
      setDate1(new Date());
      setDate2(new Date());
      setValues({
        ...values,
        operationEntityID: selectedOptionsFCC,
        fromDate: date1.toISOString().split('T')[0],
        toDate: date2.toISOString().split('T')[0]
      })
    } else {
      setSelectedOptionsFCC([]);
      setFCCSummaryDetails([]);
      setDate1(new Date());
      setDate2(new Date());
      setValues({
        ...values,
        operationEntityID: selectedOptionsFCC,
        fromDate: date1.toISOString().split('T')[0],
        toDate: date2.toISOString().split('T')[0]
      })

    }
  }

  async function clear() {
    setFCCSummaryDetails([]);
  }

  const { errors, touched, setValues, handleSubmit, getFieldProps, values } = formik;

  const renderSelectedValueFCC = (selected) => {
    if (selected.length === 0) {
      return 'Select Options';
    } else if (selected.length === 1) {
      const option = operationEntityList.find((entity) => entity.value === selected[0]);
      return option ? <Chip label={option.label} /> : '';
    } else {
      const selectedChips = selected.map((value, index) => {
        if (index === 0) {
          const option = operationEntityList.find((entity) => entity.value === value);
          return option ? <Chip label={option.label} /> : null;
        } else {
          const option = operationEntityList.find((entity) => entity.value === value);
          return option ? <Chip key={index} label={option.label} /> : null;
        }
      });
      const moreCount = selected.length - 1;
      return (
        <div>
          {selectedChips[0]} + {moreCount} more
        </div>
      );
    }
  };

  return (
    <>
      <LoadingComponent />
      <Page title="FCC Activity Summary Report |  FAPS">
        <Container>
          <CommonPageHeader
            path={'/fccActivitySummaryReport'}
            btname="Add"
            pageName="FCC Activity Summary Report "
            leftButtonHidden={true}
          />

          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Group</MenuItem>
                    {groupList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                  <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                    <InputLabel id="multi-select-label"> Operation Entity *</InputLabel>
                    <Select
                      labelId="multi-select-label"
                      id="multi-select"
                      multiple
                      size="small"
                      value={selectedOptionsFCC}
                      onChange={handleSelectChange}
                      label="Fresh Collection Center"
                      renderValue={(selected) => renderSelectedValueFCC(selected)}
                      disabled={!permissionList.isFactoryFilterEnabled}
                    >
                      <MenuItem key={0} value={""}>
                        <Checkbox checked={selectedOptionsFCC.length === operationEntityList.length} color="primary" />
                        All Operation Entity
                      </MenuItem>
                      {operationEntityList.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <Checkbox checked={selectedOptionsFCC.indexOf(option.value) > -1} color="primary" />
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {touched.operationEntityID && errors.operationEntityID && (
                      <FormHelperText>{errors.operationEntityID}</FormHelperText>
                    )}
                    {selectedOptionsFCC.length > 0 && (
                      <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                        {!permissionList.isFactoryFilterEnabled ? null :
                          <ClearIcon />}
                      </IconButton>
                    )}
                  </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    size="small"
                    id="date"
                    label=" From Date *"
                    type="date"
                    value={formik.values.fromDate}
                    onChange={formik.handleChange}
                    {...getFieldProps('fromDate')}
                    error={Boolean(touched.fromDate && errors.fromDate)}
                    helperText={touched.fromDate && errors.fromDate}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>,
                      inputProps: {
                        max: getTodayDate(),
                      },
                    }}
                  />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    size="small"
                    id="date"
                    label=" To Date *"
                    type="date"
                    value={formik.values.toDate}
                    onChange={formik.handleChange}
                    {...getFieldProps('toDate')}
                    error={Boolean(touched.toDate && errors.toDate)}
                    helperText={touched.toDate && errors.toDate}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>,
                      inputProps: {
                        max: getTodayDate(),
                      },
                    }}
                  />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="left" spacing={2}>
                    <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                      Clear
                    </Button>
                    <Button type="submit" color="secondary" variant="outlined">
                      Search
                    </Button>
                  </Stack>
                  </Grid>
                  </Grid>
                {fccSummaryDetails.length != 0 ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Card style={{ justifycontent: 'center', width: '85rem' }} >
                      <TableContainer component={Paper} >
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: "bold" }} align="left">FCC</TableCell>
                              <TableCell sx={{ fontWeight: "bold" }} align="left">Date</TableCell>
                              <TableCell sx={{ fontWeight: "bold" }} align="left">Product Code</TableCell>
                              <TableCell sx={{ fontWeight: "bold" }} align="left">Product</TableCell>
                              <TableCell sx={{ fontWeight: "bold" }} align="right">Requested Qty</TableCell>
                              <TableCell sx={{ fontWeight: "bold" }} align="right">Accepted Qty	</TableCell>
                              <TableCell sx={{ fontWeight: "bold" }} align="right">Supplied Qty</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(rowsPerPage > 0
                              ? fccSummaryDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : fccSummaryDetails).map((row) => (
                                <TableRow>
                                  <TableCell align="left">{row.factoryName}</TableCell>
                                  <TableCell align="left">{moment(row.orderDate).format("YYYY-MM-DD")}</TableCell>
                                  <TableCell align="left">{row.productCode}</TableCell>
                                  <TableCell align="left">{row.productName}</TableCell>
                                  <TableCell align="right">
                                    {row.quantity === 0 ? '-' : parseFloat(row.quantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.acceptedQuantity === 0 ? '-' : parseFloat(row.acceptedQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.netAmount === 0 ? '-' : parseFloat(row.netAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </TableCell>
                                </TableRow>
                              ))}
                            <TableRow>
                              <TableCell sx={{ fontWeight: "bold" }} colSpan={4}>Total</TableCell>
                              <TableCell sx={{ fontWeight: "bold" }} align="right">
                                {totalValues.RequestedQtyTotal === 0 ? '-' : parseFloat(totalValues.RequestedQtyTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </TableCell>
                              <TableCell sx={{ fontWeight: "bold" }} align="right">
                                {totalValues.AcceptedQtyTotal === 0 ? '-' : parseFloat(totalValues.AcceptedQtyTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </TableCell>
                              <TableCell sx={{ fontWeight: "bold" }} align="right">
                                {totalValues.SuppliedQtyTotal === 0 ? '-' : parseFloat(totalValues.SuppliedQtyTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </TableCell>
                            </TableRow>
                            {emptyRows > 0 && (
                              <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={6} />
                              </TableRow>
                            )}
                          </TableBody>
                          <TableFooter>
                            <TableRow>
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                colSpan={7}
                                count={fccSummaryDetails.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                  inputProps: {
                                    'aria-label': 'rows per page',
                                  },
                                  native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                              />
                            </TableRow>
                          </TableFooter>

                        </Table>
                      </TableContainer>
                    </Card>
                  </Stack> : <SearchNotFound searchQuery="FCC Activity Summary Details" />}
            </Form>
          </FormikProvider>

          <br />
          {fccSummaryDetails.length > 0 ?
            <Box display="flex" justifyContent="flex-end" p={2}>
              <Button
                color="primary"
                id="btnRecord"
                type="submit"
                variant="contained"
                style={{ marginRight: '1rem' }}
                className={classes.colorRecord}
                onClick={() => createFile()}
              >
                EXCEL
              </Button>
              <ReactToPrint
                documentTitle={"COP Report"}
                trigger={() => <Button
                  color="primary"
                  id="btnRecord"
                  type="submit"
                  variant="contained"
                  style={{ marginRight: '1rem', backgroundColor: 'red' }}
                  className={classes.colorCancel}
                >
                  PDF
                </Button>}
                content={() => componentRef.current}
              />
              <div hidden={true}>
                <CreatePDF ref={componentRef}
                  fccActivitySummaryList={fccSummaryDetails} searchData={selectedSearchValues}
                  totalValues={totalValues}
                />
              </div>
            </Box> : null}
        </Container>
      </Page>
    </>
  );
}
